import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';
import { DatiqButtonSizes, DatiqButtonTypes } from './datiq-button.enums';
import { IDatiqButton } from './datiq-button.interface';

export const emptyDatiqButton: IDatiqButton = {
    id: DATIQ_DEFAULT_ID('datiq-button'),
    type: DatiqButtonTypes.Primary,
    size: DatiqButtonSizes.Standard,
    label: 'Button',
};
